const doc = [({"da":({"js":({"sessions":({"new":({"index":({"sign_in":"Log ind", "create_user":"Opret bruger", "login_with":"Log ind med"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;